import { render, staticRenderFns } from "./order-money-font.vue?vue&type=template&id=34a9d317&scoped=true&"
import script from "./order-money-font.vue?vue&type=script&lang=js&"
export * from "./order-money-font.vue?vue&type=script&lang=js&"
import style0 from "./order-money-font.vue?vue&type=style&index=0&id=34a9d317&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a9d317",
  null
  
)

export default component.exports